import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { isAuthenticated } from '../../../modules/user/selectors';
import { SHOP_LOCATOR } from '../../../routes/externalLinks';
import { slipSelectionRemove } from '../actions';
import { getCurrentSlipRawSelections } from '../selectors';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { plusCardSmall } = contentStackImageUrls;

export const NewSlip = ({ userAuthenticated, selections, onRemoveSelectionButtonClick }) => (
  <div className="new-slip">
    <div className="new-slip__header">
      Bet Slip
    </div>
    <div className="new-slip-main">
      <div className="new-slip-card">
        {!userAuthenticated && (
          <div className="new-slip-box new-slip-anon-info">
            <img
              src={plusCardSmall}
              onError={(e) => { e.target.src = '../../../../assets/images/plus-card-small.png'; }}
              className="new-slip-anon-info__image"
            />
            <h1 className="new-slip-anon-info__header">
              Want to use BettingBuddy?<br />
              Not yet a PLUS customer?
            </h1>
            <p className="new-slip-anon-info__text">
              Visit a William Hill shop and sign up for a PLUS card to
              make the most of BettingBuddy and other great PLUS features.
            </p>
            <a
              className="new-slip-anon-info__action-text"
              target="_blank"
              href={SHOP_LOCATOR}
              rel="noopener noreferrer"
            >
              Find your nearest shop
            </a>
          </div>
        )}
        <ul className="new-slip-selections">
          {selections.map(selection => (
            <li className="new-slip-box" key={selection.selectionId}>
              <div className="new-slip-selections__selection-name">
                {selection.selectionName} @{' '}
                {selection.selectionPriceNum}/{selection.selectionPriceDen}
              </div>
              <div className="new-slip-selections__selection-detail">{selection.marketName}</div>
              <div className="new-slip-selections__selection-detail">{selection.eventName}</div>
              <button
                type="button"
                className="new-slip__remove-button"
                onClick={
                  () => onRemoveSelectionButtonClick(selection.selectionId)
                }
              >
                <span className="icon icon--close" />
              </button>
            </li>
          ))}
        </ul>
        <div className="new-slip__disclaimer">
          <b>Please note:</b> odds may change in the duration between slip
          generation and placing a bet in shop.
        </div>
      </div>
    </div>
  </div>
);

NewSlip.propTypes = {
  userAuthenticated: PropTypes.bool,
  selections: PropTypes.instanceOf(List),
  onRemoveSelectionButtonClick: PropTypes.func
};

NewSlip.defaultProps = {
  userAuthenticated: false,
  selections: new List(),
  onRemoveSelectionButtonClick: () => {
  }
};

const mapStateToProps = state => ({
  selections: getCurrentSlipRawSelections(state),
  userAuthenticated: isAuthenticated(state)
});

const mapDispatchToProps = {
  onRemoveSelectionButtonClick: slipSelectionRemove
};

export default connect(mapStateToProps, mapDispatchToProps)(NewSlip);
